<template>
	<b-container fluid>
		<b-row>
			<b-col>
				<card>
					<ImportLogTable></ImportLogTable>
				</card>
			</b-col>
		</b-row>
	</b-container>
</template>

<script>
import ImportLogTable from '@/components/Report/ImportLogTable.vue';

export default {
	name: 'ImportLogReport',
	components: {
		ImportLogTable
	}
};
</script>